import { jsxs, jsx } from 'react/jsx-runtime';
import { BaseRadio } from '../BaseRadio/BaseRadio.js';
import { Flex } from '../Flex/Flex.js';
import { Typography } from '../Typography/Typography.js';

const Radio = ({ children, ...props }) => {
    return (jsxs(Flex, { alignItems: "center", as: "label", gap: 2, children: [jsx(BaseRadio, { ...props }), jsx(Typography, { textColor: "neutral800", children: children })] }));
};

export { Radio };
